import { Grid } from '@mui/material'

import GridIconButton from './GridIconButton'
import { SESSI } from '../settings/settings'

const GridCategoryRequirements = ({
  index,
  x,
  values,
  onChange = () => {},
  readOnly = true,
}) => {
  const removeIndex = () =>
    onChange([...values?.slice(0, index), ...values?.slice(index + 1)])

  let text = ''
  if (x?.sesso) {
    text += SESSI?.find(s => s.key === x?.sesso)?.label
    if (x?.annoMin || x?.annoMax) text += ' '
  }

  const born = x?.sesso === 'F' ? 'nate' : 'nati'
  if (x?.annoMin && x?.annoMax) {
    text += `${born} dal ${x?.annoMin} al ${x?.annoMax}`
  } else if (x?.annoMin) {
    text += `${born} dal ${x?.annoMin} in poi`
  } else if (x?.annoMax) {
    text += `${born} fino al ${x?.annoMax}`
  }

  return (
    <Grid container spacing={1} alignItems='center' sx={{ width: '100%' }}>
      <Grid size='grow'>{text}</Grid>
      {!readOnly && (
        <GridIconButton type='delete' size='auto' onClick={removeIndex} />
      )}
    </Grid>
  )
}

export default GridCategoryRequirements
